import { lazy, Suspense, type ComponentProps } from "solid-js"
import type { Markdown as MarkdownComponent } from "@mux/ui/markdown"
import { trackRenderReadiness } from "@mux/ui/context/render-readiness"

const LazyMarkdown = lazy(() => import("@mux/ui/markdown").then((module) => ({ default: module.Markdown })))

/**
 * Loads the renderer chunk before the first message asks for it, so a chat's
 * transcript is not left blank while it downloads. The module promise is
 * cached; repeated calls cost nothing.
 */
export function preloadMarkdown() {
  void LazyMarkdown.preload().catch(() => undefined)
}

type MarkdownProps = ComponentProps<typeof MarkdownComponent>

// On a fresh page nothing renders until the renderer's code loads. A timeline
// row keeps its provisional height meanwhile instead of measuring as blank;
// the renderer reports its own progress from the update that replaces this.
function LoadingRenderer() {
  trackRenderReadiness(() => true)
  return null
}

export default function Markdown(props: MarkdownProps) {
  return (
    <Suspense fallback={<LoadingRenderer />}>
      <LazyMarkdown {...props} />
    </Suspense>
  )
}
